import { useApi } from "./api-service";

export function usePaymentsService() {
  const paymentsApi = useApi();

  return {
    createAccount: async (): Promise<string> => {
      const response = await paymentsApi.post<{ account: string }>(
        `/stripe/account`
      );
      return response.account;
    },
    createAccountSession: async (): Promise<string> => {
      const response = await paymentsApi.post<{ client_secret: string }>(
        `/stripe/account_session`
      );
      return response.client_secret;
    },
  };
}
